import {
  LoginAuthMethodsQueryCgResponse,
  LoginAuthMethodsQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const LOGIN_AUTH_METHODS_QUERY: TypedDocumentNode<
  LoginAuthMethodsQueryCgResponse,
  LoginAuthMethodsQueryVariables
> = gql`
  query LoginAuthMethods($userEmail: String) {
    loginAuthMethods(userEmail: $userEmail) {
      hasPasswordAuth
      hasSsoAuth
    }
  }
`;
